// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 502 ? "d2c86127" : chunkId) + "." + {"502":"f1d82063d6a2eff2","686":"178fa21fb114b8eb"}[chunkId] + ".js";
};